import {lazy} from 'react';

const loadOnboardingPage = () => import('./OnboardingPage');
export const OnboardingPageLoad = lazy(loadOnboardingPage);